function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.541 5.20677L16.1774 5.74083C16.5291 6.03557 16.5122 6.6345 16.1397 7.07837C16.1396 7.07845 16.1396 7.07852 16.1394 7.07845L9.1231 15.4364C8.75045 15.88 8.1637 16.0006 7.81207 15.7059L6.53913 14.6378L14.2299 5.47626C14.6026 5.0327 15.1893 4.91209 15.541 5.20677Z",
  fill: "#3370FF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.87222 10.376L3.40605 9.78314C3.69543 9.46175 4.28883 9.52067 4.74212 9.91581L9.91742 14.4271L8.91756 15.6687C8.64176 16.0112 8.0409 15.9681 7.57551 15.5725C7.56977 15.5676 7.56406 15.5627 7.5584 15.5577L3.17795 11.7217C2.71829 11.3192 2.5769 10.7218 2.86215 10.3875C2.86546 10.3836 2.86881 10.3798 2.87222 10.376Z",
  fill: "#3370FF"
});

function SvgIconYes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYes);
export default __webpack_public_path__ + "static/media/icon_yes.45b5cb45.svg";
export { ForwardRef as ReactComponent };